import { useTranslation } from "react-i18next";
import { useRegisterSW } from "virtual:pwa-register/react";
import Ic from "../components/icons.jsx";

/**
 * Registers the service worker (build-time generated by vite-plugin-pwa) and, when a
 * newer build is waiting, shows a bottom banner: "Osveži" activates it and reloads.
 * `registerType: "prompt"` — the app never swaps versions under the user's feet.
 */
export function PwaUpdateBanner() {
  const { t } = useTranslation();
  const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Look for a new build once an hour while the app stays open on a tablet.
      if (registration) setInterval(() => { void registration.update(); }, 60 * 60 * 1000);
    },
  });
  if (!needRefresh) return null;
  return (
    <div className="pwa-banner" role="status">
      <Ic.refresh aria-hidden="true" />
      <span className="pwa-banner-text">{t("pwa.updateReady", "Nova verzija aplikacije je spremna.")}</span>
      <button type="button" className="btn sm" onClick={() => setNeedRefresh(false)}>{t("pwa.later", "Kasnije")}</button>
      <button type="button" className="btn primary sm" onClick={() => { void updateServiceWorker(true); }}>{t("pwa.refresh", "Osveži")}</button>
    </div>
  );
}
